import React, { memo } from "react"
import PropTypes from "prop-types"

const ZoomButton = memo(({ onZoomOut, onZoomIn }) => (
  <div id="button_zoom_container">
    <div className="button" onClick={onZoomIn}>
      <i className="fas fa-plus" />
    </div>
    <div className="liseret" />
    <div className="button" onClick={onZoomOut}>
      <i className="fas fa-minus" />
    </div>
  </div>
))

ZoomButton.propTypes = {
  onZoomOut: PropTypes.func,
  onZoomIn: PropTypes.func,
}

ZoomButton.defaultProps = {
  onZoomOut: () => {},
  onZoomIn: () => {},
}

export default ZoomButton
